import { render } from "./ShoppingTab.vue?vue&type=template&id=7353e2e6&scoped=true"
import script from "./ShoppingTab.vue?vue&type=script&lang=js"
export * from "./ShoppingTab.vue?vue&type=script&lang=js"

import "./ShoppingTab.vue?vue&type=style&index=0&id=7353e2e6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7353e2e6"]])

export default __exports__